export default "__VITE_ASSET__eb8769f3__"